import { lazy, Suspense, useContext } from 'react'
import { WalletReadyContext } from '@/lib/walletContext'

const ColonyFollowButtonInnerLazy = lazy(() => import('@/components/ColonyFollowButtonInner'))

export default function ColonyFollowButton({
  favoriteWallet,
  compact = false,
}: {
  favoriteWallet: string
  compact?: boolean
}) {
  const ready = useContext(WalletReadyContext)
  if (!ready) {
    return (
      <p className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-center text-xs text-zinc-500">
        Connect a wallet to follow
      </p>
    )
  }

  return (
    <Suspense
      fallback={(
        <p className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-center text-xs text-zinc-500">
          Connect a wallet to follow
        </p>
      )}
    >
      <ColonyFollowButtonInnerLazy favoriteWallet={favoriteWallet} compact={compact} />
    </Suspense>
  )
}
